"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terms = void 0;
exports.terms = function (axios) {
    return {
        // 도메인 / 보안서버 신청 시 약관 조회
        getCommerceTerms: function (params) {
            return axios.get('/api/read-terms.gd', { params: params, headers: {} });
        },
    };
};
